import {http} from './http'

let configPromise = null

export const publicConfig = {
    getConfig: async () => {
        if (!configPromise) configPromise = http.get('/api/v1/public/config').then(r => r.data)
        return configPromise
    },
}
